import type { ReactNode } from 'react';

/**
 * Without `can_download`: no native context menu ("Save image as…") and no dragging images out of the page.
 * Deterrent only (spec §9.3): anything a browser shows can be captured.
 */
export function Restricted({ canDownload, children }: { canDownload: boolean; children: ReactNode }) {
  if (canDownload) return <>{children}</>;
  return (
    <div className="contents" onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()}>
      {children}
    </div>
  );
}
